import { VectorFieldScores } from "../path/VectorFieldScores";
import GridTile from "./GridTile";

export default class PathData {
    constructor() {
        /**
         * @type {number}
         */
        this.pathNumber = 0;
        /**
         * @type {boolean}
         */
        this.closed = false;
        /**
         * @type {GridTile}
         */
        this.cameFrom = null;
        /**
         * @type {number}
         */
        this.cost = 0;
        /**
         * @type {number}
         */
        this.score = 0;
        /**
         * @type {boolean}
         */
        this.inOpenList = false;

        /**
         * @type {number}
         */
        this.mineScore = -1;
        /**
         * @type {number}
         */
        this.mineVectorFieldNumber = -1;
    


    }

    /**
     * @param {number} pathNumber 
     * @returns {GridTile}
     */
    getCameFrom(pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }
        return this.cameFrom;
    }

    /**
     * @param {GridTile} cameFrom 
     * @param {number} cost 
     * @param {number} score 
     * @param {number} pathNumber 
     */
    set(cameFrom, cost, score, pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }

        this.cameFrom = cameFrom;
        this.cost = cost;
        this.score = score;
    }

    /**
     * @param {number} pathNumber 
     * @returns {number}
     */
    getCost(pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }
        return this.cost;
    }

    /**
     * @param {number} cost 
     * @param {number} pathNumber 
     */
    setCost(cost, pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }
        this.cost = cost;
    }

    /**
     * @param {number} pathNumber 
     * @returns {number}
     */
    getScore(pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }
        return this.score;
    }

    /**
     * @param {boolean} closed 
     * @param {number} pathNumber 
     */
    setClosed(closed, pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }
        this.closed = closed;
    }

    /**
     * @param {number} pathNumber 
     * @returns {boolean}
     */
    isClosed(pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }
        return this.closed;
    }

    /**
     * @param {boolean} inOpenList 
     * @param {number} pathNumber 
     */
    setInOpenList(inOpenList, pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }
        this.inOpenList = inOpenList;
    }

    /**
     * @param {number} pathNumber 
     * @returns {boolean}
     */
    isInOpenList(pathNumber) {
        if (this.pathNumber != pathNumber) {
            this.reset(pathNumber);
        }
        return this.inOpenList;
    }

    /**
     * @param {number} vectorFieldNumber 
     * @returns {number}
     */
    getMineScore(vectorFieldNumber) {
        if (this.mineVectorFieldNumber != vectorFieldNumber) {
            return VectorFieldScores.UNSET; // The tile is out of bounds
        }
        else {
            return this.mineScore;
        }
    }

    /**
     * @param {number} mineScore 
     * @param {number} vectorFieldNumber 
     */
    setMineScore(mineScore, vectorFieldNumber) {
        this.mineVectorFieldNumber = vectorFieldNumber;
        this.mineScore = mineScore;
    }

    /**
     * @private
     * @param {number} pathNumber 
     */
    reset(pathNumber) {
        this.pathNumber = pathNumber;
        this.closed = false;
        this.cameFrom = null;
        this.cost = 0;
        this.score = 0;
        this.inOpenList = false;        

        // Don't reset vector field stuff here.
    }

}